import { useMutation, useQueryClient } from "@tanstack/react-query";
import { downloadOverTimeReport } from "../api/overtimeScheduleApi";
import { OvertimeWorkedAndScheduledPerPeriodRequest } from "../models/OvertimeSchedule";

export const useDownloadOvertimeReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: Omit<
        OvertimeWorkedAndScheduledPerPeriodRequest,
        "preliquidateTypeId"
      >,
    ) => downloadOverTimeReport(body),
  });
};
